import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class CustomQuoteService {
    /**
     * Selects a quote
     * @param {String} quoteID the quote ID
     * @param {String} branchName the name of the selected quote
     * @param {String} sessionUUID the session UUID associated to the quoteID
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    static setSelectedVersionOnSubmission(
        quoteID,
        branchName,
        sessionUUID,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'setSelectedVersionOnSubmission',
            [quoteID, branchName, sessionUUID],
            additionalHeaders
        );
    }

    /**
     * Updates a custom quote
     * @param {Object} customQuoteDTO CustomQuoteDataDTO
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    static updateCustomQuote(customQuoteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'updateCustomQuote',
            [customQuoteDTO],
            additionalHeaders
        );
    }

    /**
     * Updates a custom quote coverage
     * @param {Object} customQuoteDTO CustomQuoteDataDTO
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    static updateCustomQuoteCoverages(customQuoteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'updateCustomQuoteCoverages',
            [customQuoteDTO],
            additionalHeaders
        );
    }

    /**
     * Force Updates a custom quote coverage
     * @param {Object} customQuoteDTO CustomQuoteDataDTO
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    static forceUpdateCustomQuoteCoverages(
        customQuoteDTO,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/customquote'),
            'forceUpdateCustomQuoteCoverages',
            [customQuoteDTO],
            additionalHeaders
        );
    }

    // US26344
    static applyCodes(reqDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('quoteutils'),
            'applyCodes',
            [reqDTO],
            additionalHeaders
        );
    }

    // US26344
    static postalCodesEastOfHwy146(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('quoteutils'),
            // eslint-disable-next-line no-secrets/no-secrets
            'postalCodesEastOfHwy146',
            [],
            additionalHeaders
        );
    }

    // US26350
    static saveAndGenerateOfferingTwia(data, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayquote/quote'),
            'saveAndGenerateOffering_TWIA',
            [data],
            additionalHeaders
        );
    }

    // US26348
    static generateDocument_TWIA(publicID, page,additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('documentgeneration'),
            'generateDocument_TWIA',
            [publicID, page],
            additionalHeaders
        );
    }

    // US26292 and US26874
    static isProducerEmail(email,additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayOrganization'),
            'isProducerEmail',
            [email],
            additionalHeaders
        );
    }

    static maxAmountCanFinance(quoteID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('quoteutils'),
            'maxAmountCanFinance',
            [quoteID],
            additionalHeaders
        );
    }

    static retrieveInstallments(quoteID, planID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policy'),
            'retrieveInstallmentsPreview',
            [quoteID, planID],
            additionalHeaders
        );
    }

    static getUWIssueStatus(quoteID, sessionID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policyhold'),
            'getUWIssueStatus',
            [quoteID, sessionID],
            additionalHeaders
        );
    }
}
